// @ts-nocheck
import { Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";

export const GmailCheckbox = ({
  checked,
  indeterminate,
  onChange,
  fillColor,
}) => {
  return (
    <Checkbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
      checkedIcon={<CheckBoxIcon fontSize="small" />}
      indeterminateIcon={<IndeterminateCheckBoxIcon />}
      sx={{
        height: 2,
        width: 2,
        mr: 1,
        color: "#5f6368",
        "&:hover": {
          backgroundColor: "rgba(60,64,67,0.08)",
          borderRadius: "50%",
        },
        "&.Mui-checked": {
          color:
            fillColor ??
            getCssVariableHandler({ variableName: "--primary-pink-hex" }),
        },
      }}
    />
  );
};
GmailCheckbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  fillColor: PropTypes.string,
};